// The gate pass — per-session, per-user memory of "the gate already resolved
// to ready". Once a user passes, remounts of AuthGuard (e.g. crossing the
// (app) <-> (marketplace) route-group boundary) must NOT re-block the screen
// with the loading cover; AuthGuard starts optimistically from this and
// revalidates in the background. The arrival ceremony arms it the moment
// provisioning succeeds, so the walk into /home never re-covers the screen
// for a verdict this session already holds.
//
// In-memory ONLY, keyed by user id — never persisted: a stored mark lied
// after an out-of-band account deletion (founder, 08-03), and a different or
// signed-out user must never inherit a pass. This governs only the client-
// side loading VISUAL — server middleware remains the primary access gate.

let readyUserId: string | null = null;

export const gatePass = {
  isReady(userId: string): boolean {
    return readyUserId === userId;
  },
  arm(userId: string): void {
    readyUserId = userId;
  },
  clear(): void {
    readyUserId = null;
  },
};
